//
// Copyright 2023 DXOS.org
//

export const DXOS_VERSION = '0.14.0';
